export const PENJUALAN_ALL_CABANG_GET_REQUEST =
  "PENJUALAN_ALL_CABANG_GET_REQUEST";
export const PENJUALAN_ALL_CABANG_GET_SUCCESS =
  "PENJUALAN_ALL_CABANG_GET_SUCCESS";
export const PENJUALAN_ALL_CABANG_GET_FAIL = "PENJUALAN_ALL_CABANG_GET_FAIL";
export const PENJUALAN_ALL_CABANG_GET_RESET = "PENJUALAN_ALL_CABANG_GET_RESET";
